// Generated by services/runtime/scripts/sync_report_template_catalog.py.
// Do not edit directly.
export const coworkReportRegistrySchemaVersion = 5 as const

export const coworkReportRegistryTemplates = [
  {
    "id": "trial-balance",
    "version": 1,
    "domain": "accounting",
    "reportType": "trial_balance_analysis",
    "jurisdiction": "EE",
    "availability": "enabled",
    "validationMaturity": "integrated",
    "definition": {
      "parameters": {
        "required": [
          "entity_scope",
          "period"
        ],
        "optional": [
          "report_language"
        ]
      },
      "datasets": {
        "required": [
          "ledger@1"
        ],
        "optional": []
      },
      "outputs": [
        "xlsx"
      ],
      "renderer": {
        "id": "estonia-ledger-workbook",
        "version": 1
      }
    },
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-trial-balance-analysis",
      "accounting-classification",
      "accounting-memory",
      "accounting-posting-generation",
      "accounting-payment-reconciliation",
      "accounting-reporting",
      "estonia-accounting",
      "estonia-accounting-taxonomy",
      "estonia-kaibeandmik"
    ]
  },
  {
    "id": "journal",
    "version": 1,
    "domain": "accounting",
    "reportType": "accounting_journal",
    "jurisdiction": "EE",
    "availability": "enabled",
    "validationMaturity": "integrated",
    "definition": {
      "parameters": {
        "required": [
          "entity_scope",
          "period"
        ],
        "optional": [
          "report_language"
        ]
      },
      "datasets": {
        "required": [
          "ledger@1"
        ],
        "optional": []
      },
      "outputs": [
        "xlsx"
      ],
      "renderer": {
        "id": "estonia-ledger-workbook",
        "version": 1
      }
    },
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-classification",
      "accounting-memory",
      "accounting-posting-generation",
      "accounting-reporting",
      "estonia-accounting",
      "estonia-accounting-taxonomy",
      "estonia-kaibeandmik",
      "estonia-paevaaramat"
    ]
  },
  {
    "id": "account-card",
    "version": 1,
    "domain": "accounting",
    "reportType": "account_card",
    "jurisdiction": "EE",
    "availability": "enabled",
    "validationMaturity": "integrated",
    "definition": {
      "parameters": {
        "required": [
          "account_selection",
          "entity_scope",
          "period"
        ],
        "optional": [
          "report_language"
        ]
      },
      "datasets": {
        "required": [
          "ledger@1"
        ],
        "optional": []
      },
      "outputs": [
        "xlsx"
      ],
      "renderer": {
        "id": "account-card-workbook",
        "version": 1
      }
    },
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-account-card",
      "accounting-reporting",
      "estonia-accounting"
    ]
  },
  {
    "id": "pnl",
    "version": 1,
    "domain": "accounting",
    "reportType": "pnl_analysis",
    "jurisdiction": null,
    "availability": "enabled",
    "validationMaturity": "contract",
    "definition": null,
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-pnl-analysis",
      "accounting-reporting"
    ]
  },
  {
    "id": "balance-sheet",
    "version": 1,
    "domain": "accounting",
    "reportType": "balance_sheet_analysis",
    "jurisdiction": null,
    "availability": "enabled",
    "validationMaturity": "contract",
    "definition": null,
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-balance-sheet-analysis",
      "accounting-reporting"
    ]
  },
  {
    "id": "management-report",
    "version": 1,
    "domain": "accounting",
    "reportType": "management_report",
    "jurisdiction": null,
    "availability": "enabled",
    "validationMaturity": "contract",
    "definition": null,
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-management-report",
      "accounting-reporting"
    ]
  },
  {
    "id": "cash-bank",
    "version": 1,
    "domain": "accounting",
    "reportType": "cash_bank_analysis",
    "jurisdiction": null,
    "availability": "enabled",
    "validationMaturity": "contract",
    "definition": null,
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-cash-bank-analysis",
      "accounting-reporting"
    ]
  },
  {
    "id": "ar-ap-aging",
    "version": 1,
    "domain": "accounting",
    "reportType": "ar_ap_analysis",
    "jurisdiction": null,
    "availability": "enabled",
    "validationMaturity": "contract",
    "definition": null,
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-ar-ap-analysis",
      "accounting-reporting"
    ]
  },
  {
    "id": "estonia-bilanss",
    "version": 1,
    "domain": "accounting",
    "reportType": "estonia_bilanss",
    "jurisdiction": "EE",
    "availability": "enabled",
    "validationMaturity": "contract",
    "definition": null,
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-balance-sheet-analysis",
      "accounting-reporting",
      "estonia-accounting",
      "estonia-fixed-assets",
      "estonia-bilanss"
    ]
  },
  {
    "id": "estonia-kasumiaruanne",
    "version": 1,
    "domain": "accounting",
    "reportType": "estonia_kasumiaruanne",
    "jurisdiction": "EE",
    "availability": "enabled",
    "validationMaturity": "contract",
    "definition": null,
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-pnl-analysis",
      "accounting-reporting",
      "estonia-accounting",
      "estonia-accounting-taxonomy",
      "estonia-pnl-classification",
      "estonia-kasumiaruanne"
    ]
  },
  {
    "id": "estonia-kmd",
    "version": 1,
    "domain": "accounting",
    "reportType": "kmd",
    "jurisdiction": "EE",
    "availability": "enabled",
    "validationMaturity": "integrated",
    "definition": {
      "parameters": {
        "required": [
          "entity_scope",
          "period"
        ],
        "optional": [
          "report_language"
        ]
      },
      "datasets": {
        "required": [
          "kmd-declaration@1"
        ],
        "optional": [
          "kmd-review@1"
        ]
      },
      "outputs": [
        "xml",
        "xlsx"
      ],
      "renderer": {
        "id": "estonia-kmd-xml",
        "version": 1
      }
    },
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-reporting",
      "estonia-accounting",
      "estonia-tax-account-mapping",
      "estonia-vat"
    ]
  },
  {
    "id": "estonia-tsd",
    "version": 1,
    "domain": "accounting",
    "reportType": "tsd",
    "jurisdiction": "EE",
    "availability": "enabled",
    "validationMaturity": "integrated",
    "definition": {
      "parameters": {
        "required": [
          "entity_scope",
          "period"
        ],
        "optional": [
          "report_language"
        ]
      },
      "datasets": {
        "required": [
          "tsd-declaration@1"
        ],
        "optional": [
          "tsd-review@1"
        ]
      },
      "outputs": [
        "xml",
        "xlsx"
      ],
      "renderer": {
        "id": "estonia-tsd-xml",
        "version": 1
      }
    },
    "requiredSkills": [
      "accounting-data-model",
      "accounting-validation",
      "accounting-reporting",
      "estonia-accounting",
      "estonia-tax-account-mapping",
      "estonia-payroll"
    ]
  }
] as const

export const coworkAgentRegistry = {
  "dashboard": {
    "domain": "dashboards",
    "runtime_agent": "dashboard-agent",
    "mode": "primary",
    "permissions": {
      "read": "allow",
      "edit": "allow",
      "question": "allow",
      "webfetch": "allow",
      "websearch": "allow",
      "external_directory": "deny",
      "bash": "allow",
      "andmera_run_get": "allow",
      "andmera_platform_context": "allow",
      "andmera_records_read": "allow",
      "andmera_financial_report_read": "allow",
      "andmera_financial_report_save": "allow",
      "andmera_proposal_save": "allow",
      "andmera_dashboard_save": "allow",
      "andmera_dashboard_context": "allow",
      "andmera_dashboard_source": "allow",
      "andmera_source_get": "allow",
      "andmera_knowledge_search": "allow",
      "andmera_employees_list": "deny",
      "andmera_pension_lookup": "deny",
      "andmera_ledger_snapshot_reuse": "allow",
      "andmera_report_registry": "allow",
      "andmera_event_normalize": "allow",
      "andmera_report_persist": "allow",
      "andmera_file_bundle_save": "allow"
    },
    "tools": {
      "readFiles": true,
      "generateReports": true,
      "webSearch": true,
      "calculations": true
    },
    "reporting": {
      "contract_version": "draft.v1"
    }
  },
  "custom-report": {
    "domain": "reporting",
    "runtime_agent": "custom-report-agent",
    "mode": "primary",
    "permissions": {
      "read": "allow",
      "edit": "allow",
      "question": "allow",
      "webfetch": "allow",
      "websearch": "allow",
      "external_directory": "deny",
      "bash": "allow",
      "andmera_run_get": "allow",
      "andmera_platform_context": "allow",
      "andmera_records_read": "allow",
      "andmera_financial_report_read": "allow",
      "andmera_financial_report_save": "allow",
      "andmera_proposal_save": "allow",
      "andmera_dashboard_save": "allow",
      "andmera_dashboard_context": "deny",
      "andmera_dashboard_source": "deny",
      "andmera_source_get": "allow",
      "andmera_knowledge_search": "allow",
      "andmera_employees_list": "deny",
      "andmera_pension_lookup": "deny",
      "andmera_ledger_snapshot_reuse": "allow",
      "andmera_report_registry": "allow",
      "andmera_event_normalize": "allow",
      "andmera_report_persist": "allow",
      "andmera_file_bundle_save": "allow"
    },
    "tools": {
      "readFiles": true,
      "generateReports": true,
      "webSearch": true,
      "calculations": true
    },
    "reporting": {
      "contract_version": "draft.v1"
    }
  },
  "accounting": {
    "domain": "accounting",
    "runtime_agent": "accounting-agent",
    "mode": "primary",
    "permissions": {
      "read": "allow",
      "edit": "allow",
      "question": "allow",
      "webfetch": "allow",
      "websearch": "allow",
      "external_directory": "deny",
      "bash": "allow",
      "andmera_run_get": "allow",
      "andmera_platform_context": "allow",
      "andmera_records_read": "allow",
      "andmera_financial_report_read": "allow",
      "andmera_financial_report_save": "allow",
      "andmera_proposal_save": "allow",
      "andmera_dashboard_save": "allow",
      "andmera_dashboard_context": "deny",
      "andmera_dashboard_source": "deny",
      "andmera_source_get": "allow",
      "andmera_knowledge_search": "allow",
      "andmera_employees_list": "allow",
      "andmera_pension_lookup": "allow",
      "andmera_ledger_snapshot_reuse": "allow",
      "andmera_report_registry": "allow",
      "andmera_event_normalize": "allow",
      "andmera_report_persist": "allow",
      "andmera_file_bundle_save": "allow",
      "andmera_books_read": "allow"
    },
    "tools": {
      "readFiles": true,
      "generateReports": true,
      "webSearch": true,
      "calculations": true
    },
    "reporting": {
      "contract_version": "draft.v1"
    }
  }
} as const
